import {createDonationOrder} from "./actions/createDonationOrder";
import {changeLanguage} from "./actions/changeLanguage";
import {fetchPreCheckout} from "./actions/fetchPreCheckout";

export const actions = {
    createDonationOrder,
    changeLanguage,
    fetchPreCheckout,
};
